import i18n from 'services/base/i18n';

export default {
  mondayFull:     () => i18n.pgettext('Enums|Weekdays', 'Monday'),
  tuesdayFull:    () => i18n.pgettext('Enums|Weekdays', 'Tuesday'),
  wednesdayFull:  () => i18n.pgettext('Enums|Weekdays', 'Wednesday'),
  thursdayFull:   () => i18n.pgettext('Enums|Weekdays', 'Thursday'),
  fridayFull:     () => i18n.pgettext('Enums|Weekdays', 'Friday'),
  saturdayFull:   () => i18n.pgettext('Enums|Weekdays', 'Saturday'),
  sundayFull:     () => i18n.pgettext('Enums|Weekdays', 'Sunday'),

  mondayShort:    () => i18n.pgettext('Enums|Weekdays', 'Mon'),
  tuesdayShort:   () => i18n.pgettext('Enums|Weekdays', 'Tue'),
  wednesdayShort: () => i18n.pgettext('Enums|Weekdays', 'Wed'),
  thursdayShort:  () => i18n.pgettext('Enums|Weekdays', 'Thu'),
  fridayShort:    () => i18n.pgettext('Enums|Weekdays', 'Fri'),
  saturdayShort:  () => i18n.pgettext('Enums|Weekdays', 'Sat'),
  sundayShort:    () => i18n.pgettext('Enums|Weekdays', 'Sun'),

  mondayMicro:    () => i18n.pgettext('Enums|Weekdays', 'M'),
  tuesdayMicro:   () => i18n.pgettext('Enums|Weekdays', 'T'),
  wednesdayMicro: () => i18n.pgettext('Enums|Weekdays', 'W'),
  thursdayMicro:  () => i18n.pgettext('Enums|Weekdays', 'Th'),
  fridayMicro:    () => i18n.pgettext('Enums|Weekdays', 'F'),
  saturdayMicro:  () => i18n.pgettext('Enums|Weekdays', 'S'),
  sundayMicro:    () => i18n.pgettext('Enums|Weekdays', 'Su'),
};
